import o from "./ghl-ui.es1235.js";
import r from "./ghl-ui.es728.js";
var t = o(r, "Promise");
const i = t;
export {
  i as default
};
